import React from 'react';


const PeerGroupRankingComponent = () => {
  const peerRanking="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/Roots+and+Wings%2C+3lens+and+LSG/Peer+Ranking+group.png";
  return (
    <div className="bg-white">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="flex flex-col md:flex-row items-center gap-8">
          {/* Image side */}
          <div className="w-full md:w-2/5">
            <img 
              src={peerRanking} 
              alt="Peer Group Ranking" 
              className="rounded-lg w-full h-auto object-cover"
            />
          </div>
          
          {/* Content side */}
          <div className="w-full md:w-3/5">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">Lens 3: Peer Group Ranking</h2>
            <h3 className="text-lg font-medium text-gray-800 mb-4">Focus: Performance vs. Peers and Benchmarks</h3>
            
            <p className="text-gray-700 mb-4">
              We don't just look at returns in isolation. We measure how a fund performs 
              <strong> relative to others in its category</strong>, using rolling returns and 
              risk-adjusted metrics.
            </p>
            
            <h4 className="font-medium text-[#113262] mb-2">Our tools include:</h4>
            <ul className="mb-4 space-y-2">
              {[
                'Quartile-based peer ranking',
                'Rolling return analysis (3, 5, 7 years)',
                'Monthly rank movement tracking'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-gray-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            
            <h4 className="font-medium text-[#113262] mb-2">Red flags:</h4>
            <ul className="mb-4 space-y-2">
              {[
                'Funds consistently ranked in bottom quartiles',
                'Funds that fail to beat benchmarks over medium to long-term',
                'High volatility without commensurate returns'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            
            <p className="text-gray-700">
              This lens helps us avoid underperformers, no matter how popular their names may be.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeerGroupRankingComponent;